import React from 'react';


function Phone() {
  return (
    <svg className="phone-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 30 30">
      <path fill="#FFF" d="M24.02 30h-.03c-5.01-.164-10.88-5.02-14.925-9.068C5.015 16.885.16 11.013.003 6.026c-.058-1.75 4.237-4.862 4.28-4.893 1.115-.776 2.352-.5 2.86.203.344.476 3.6 5.409 3.953 5.969.368.58.313 1.445-.145 2.312-.253.482-1.092 1.956-1.485 2.643.425.605 1.547 2.086 3.865 4.404 2.32 2.318 3.8 3.443 4.406 3.867.687-.393 2.161-1.232 2.643-1.484.854-.453 1.714-.51 2.3-.151.599.367 5.518 3.638 5.971 3.953.38.268.625.727.675 1.26.046.54-.12 1.11-.467 1.607-.028.042-3.104 4.284-4.838 4.284z">
      </path>
    </svg>
  );
}

export default Phone;
